/**
 * Заглушка для шаблонных строк, чтобы редактор кода (например, Prettier или VS Code)
 * распознавал и красиво форматировал HTML внутри JS/TS файлов.
 *
 * Эта функция не изменяет поведение кода, а просто возвращает итоговую строку.
 * Используйте её для улучшения читаемости и автоподсветки HTML в шаблонных строках.
 *
 * @example
 * // Пример использования:
 * const myHtml = html`
 *   <div class="block">
 *     <span>${someValue}</span>
 *   </div>
 * `;
 *
 * @param {TemplateStringsArray} strings - Части шаблонной строки.
 * @param {...any} values - Вставляемые значения.
 * @returns {string} Итоговая HTML-строка.
 */
export const html = (strings, ...values) => strings.reduce((acc, str, i) => acc + str + (values[i] ?? ""), "");
